// src/components/DressPreviewCanvas.js

import React from "react";

const DressPreviewCanvas = ({ loading, error, generatedImage, handleAddToCart }) => {
  const renderInitialState = () => (
    <div className="text-center">
      <div className="text-5xl mb-4">✨</div>
      <h2 className="text-xl font-semibold text-gray-700">
        Your Dress Will Appear Here
      </h2>
      <p className="text-gray-500 mt-2">
        Complete the steps on the left to generate your unique design.
      </p>
    </div>
  );

  return (
    // Make this container's height responsive
    <div className="w-full h-auto lg:h-full bg-white/60 backdrop-blur-sm rounded-2xl shadow-xl flex flex-col items-center justify-center p-4 sm:p-6 text-center transition-all duration-300">
      {loading && <p>Generating your masterpiece...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && !error && !generatedImage && renderInitialState()}

      {!loading && !error && generatedImage && (
        // Also make this inner container's height responsive
        <div className="w-full h-auto lg:h-full flex flex-col items-center">
          <div className="flex-grow w-full flex items-center justify-center overflow-hidden py-4">
            <img
              src={generatedImage}
              alt="Custom designed dress"
              className="max-w-full max-h-full object-contain"
            />
          </div>

          {/*{generatedImage && !loading && (
          <button
            onClick={handleAddToCart}
            className="w-full mt-3 py-3 sm:py-3.5 px-6 text-md sm:text-lg font-semibold rounded-lg transition-all duration-300 transform hover:scale-[1.02] focus:outline-none focus:ring-4 bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-md hover:from-green-600 hover:to-emerald-600 focus:ring-emerald-300"
          >
            Add To Cart
          </button>
        )}*/}
        </div>
      )}
    </div>
  );
};

export default DressPreviewCanvas;
